<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
    <iframe-popup :src="iframeSrc" v-if="iframePopupVisible"></iframe-popup>
    <video-popup :src="videoSrc" v-if="videoPopupVisible"></video-popup>
    <ModalIdle v-if="isIdle" />
    <HelpPopup />
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';
import store from '@/store/store';
import IframePopup from '@/components/UI/IframePopup';
import VideoPopup from '@/components/UI/VideoPopup';
import ModalIdle from '@/components/ModalIdle';
//import router from "@/router/router";
import Echo from 'laravel-echo';
import HelpPopup from '@/components/HelpPopup';
export default {
  name: 'App',
  components: {
    VideoPopup,
    IframePopup,
    ModalIdle,
    HelpPopup,
  },
  computed: {
    iframeSrc() {
      return this.$store.getters['popup/iframePopupSrc'];
    },
    iframePopupVisible() {
      return this.$store.getters['popup/iframePopupVisible'];
    },
    videoSrc() {
      return this.$store.getters['popup/videoPopupSrc'];
    },
    videoPopupVisible() {
      return this.$store.getters['popup/videoPopupVisible'];
    },
    /*isIdle() {
      const loginType = localStorage.getItem('login_type');

      return (loginType == 'student' || loginType == 'teacher') && this.$store.state.idleVue.isIdle;
    }*/
  },
  data() {
    return {
      vueAppClasses: [],
      isIdle: false,
    };
  },
  onIdle() {
    const loginType = localStorage.getItem('login_type');

    if (loginType == 'student' || loginType == 'teacher') this.isIdle = true;
  },
  onActive() {
    this.isIdle = false;
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr');
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY);
    },
    setIsIdle(val) {
      this.isIdle = val;
    },
  },
  provide: function () {
    return {
      setIsIdle: this.setIsIdle,
    };
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth);

    this.$router.afterEach((to, from) => {
      setTimeout(() => {
        const el = document.querySelector('h1') || document.getElementById('main-content');

        if (!el) {
          return;
        }

        el.setAttribute('tabindex', '-1');
        el.focus();
      }, 500);
    });

    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  beforeCreate() {
    const loggedType = localStorage.getItem('login_type');
    if (loggedType === 'student') {
      store.dispatch('authStudent/tryLogin').then(
        () => {},
        () => {
          window.location.href = '/';
        },
      );
    } else if (loggedType === 'teacher') {
      store.dispatch('authTeacher/tryLogin').then(
        () => {},
        () => {
          window.location.href = '/';
        },
      );
    }
  },
  created() {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);

    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
